/** Brief 12, the sign-in screens, the onboarding wizard and the pages a client opens from a link. */
export const ruB12Auth = {
  "auth.title": "Вход",
  "auth.email": "Эл. почта",
  "auth.password": "Пароль",
  "auth.submit": "Войти",
  "auth.submitting": "Вход…",
  "auth.forgot": "Забыли пароль?",
  "auth.invalidCredentials": "Неверная почта или пароль. Попробуйте ещё раз.",
  "authPanel.title": "Ни один клиент не забыт",
  "authPanel.body": "Kapitan AI отвечает первым, а вы знаете, кому, когда и что нужно сделать.",
  "authPanel.route.lead": "Обращение",
  "authPanel.route.offer": "Предложение",
  "authPanel.route.payment": "Оплата",
  "authPanel.footer": "CRM для турагентств · Узбекистан и Центральная Азия",
  "auth.lead": "Войдите с учётной записью агентства.",
  "auth.emailPlaceholder": "imya@agentstvo.uz",
  "auth.passwordPlaceholder": "Минимум 8 символов",
  "auth.notConnected": "Агентство ещё не подключено?",
  "auth.applyLink": "Оставьте заявку",

  "onb.setup": "{name} · настройка",
  "onb.stepOf": "Шаг {current} из {total}",
  "onb.back": "Назад",
  "onb.next": "Продолжить",
  "onb.finish": "Готово",
  "onb.pendingHint": "Невыполненные шаги будут отложены. Вернуться к ним можно в любой момент.",
  "onb.reopen": "Открыть снова",
  "onb.skippedList": "Отложено: {name}",
  "onb.state.pending": "Не выполнено",
  "onb.state.done": "Выполнено",
  "onb.state.skipped": "Позже",
  "onb.loadError": "Не удалось загрузить данные.",
  "onb.changeError": "Не удалось изменить шаг.",
  "onb.rowsError": "Не удалось загрузить список.",
  "onb.connected": "подключён",
  "onb.notConnected": "не подключён",
  "onb.stage.agency": "Агентство",
  "onb.stage.agency.title": "Данные агентства",
  "onb.stage.agency.body": "Название, логотип и контакты видны на публичных страницах.",
  "onb.stage.channels": "Каналы",
  "onb.stage.channels.title": "Каналы",
  "onb.stage.channels.body": "Подключите места, куда пишут клиенты. Kapitan AI отвечает в этих каналах первым.",
  "onb.stage.providers": "Туроператоры",
  "onb.stage.providers.title": "Туроператоры",
  "onb.stage.providers.body": "Введите логин или API-ключ. Цены и сообщения о бронях приходят отсюда.",
  "onb.stage.team": "Команда",
  "onb.stage.team.title": "Команда",
  "onb.stage.team.body": "Пригласите операторов и закрепите их за филиалом.",
  "onb.stage.ai": "Kapitan AI",
  "onb.stage.ai.title": "Kapitan AI",
  "onb.stage.ai.body": "Выберите тон и разрешения. Новое агентство начинает в режиме наблюдения.",

  "public.contactOperator": "Связаться с оператором",
  "public.madeWith": "Создано в Kapitan",
  "public.gone": "Ссылка не найдена или срок её действия истёк.",

  "offer.kicker": "Личное предложение · действует до {date}",
  "offer.title": "Для вас вариантов: {count}",
  "offer.people": "{count} чел.",
  "offer.nights": "{count} ноч.",
  "offer.pricesAsOf": "цены на {date}",
  "offer.choose": "Выбрать этот вариант",
  "offer.chosen": "Выбрано",
  "offer.chooseFailed": "Не удалось сохранить выбор. Попробуйте ещё раз.",
  "offer.empty": "В этом предложении пока нет вариантов.",
  "offer.gone": "Срок этого предложения истёк, или его не существует.",
  "offer.loadFailed": "Не удалось загрузить предложение.",
  "offer.images": "Фото",
  "offer.room": "Номер",
  "offer.dates": "Дата",
  "offer.priceValid": "Цена действует",
  "offer.until": "до {date}",
  "offer.toAirport": "До аэропорта {km} км",

  "sign.kicker": "Договор",
  "sign.title": "Договор на подпись",
  "sign.signedTitle": "Подписанный договор",
  "sign.smsSign": "Подписать кодом из SMS",
  "sign.pdfDownload": "Скачать PDF",

  "review.kicker": "Отзыв",
  "review.title": "Как прошла поездка?",
  "review.rating": "Оценка",
  "review.comment": "Комментарий (необязательно)",
  "review.submit": "Отправить",
  "review.failed": "Не удалось отправить. Попробуйте ещё раз.",
  "review.thanks": "Спасибо",
  "review.thanksBody": "Ваш отзыв принят.",
  "review.loadFailed": "Не удалось загрузить страницу.",
} as const;
